import React from 'react'
import { Modal } from 'antd'

// Modal cảnh báo riêng cho đơn request chụp ảnh ở màn dán label.
// Mục tiêu: nhân viên dán label nhìn phát là biết đây KHÔNG phải đơn ship thường
// (khác hẳn các lỗi khác như hold ship), nên text "ĐƠN CHỤP ẢNH - ĐỂ RIÊNG"
// cố tình để to & nổi bật ở giữa màn hình.
export default function showRequestPhotoModal(detailMessage) {
    Modal.warning({
        icon: null,
        width: 600,
        style: { top: 40 },
        okText: 'Đóng',
        okButtonProps: { size: 'large' },
        content: (
            <div style={{ textAlign: 'center', padding: '12px 0' }}>
                <div style={{ fontSize: 56, lineHeight: 1, marginBottom: 12 }}>
                    <span role="img" aria-label="camera">📸</span>
                </div>
                <div
                    style={{
                        fontSize: 40,
                        fontWeight: 800,
                        lineHeight: 1.2,
                        letterSpacing: 1,
                        color: '#d4380d',
                        marginBottom: 16,
                    }}
                >
                    ĐƠN CHỤP ẢNH<br />ĐỂ RIÊNG
                </div>
                {detailMessage && (
                    <div style={{ fontSize: 18, color: '#595959' }}>{detailMessage}</div>
                )}
            </div>
        ),
    })
}
